<template>
  <div class="download">
    <div class="logo"></div>

    <h1>
      iBolus
    </h1>

    <h3>
      Development apps
    </h3>

    <div>
      <a class="button button-primary" href="https://ibolus.page.link/android">
        <div class="download-button">Download for Android</div>
      </a>

      <p><strong>iOS</strong> Download from the TestFlight link</p>
    </div>
  </div>
</template>

<style scoped>
.download {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Roboto", sans-serif;
  background: #111;
  color: #fff;
  height: 100vh;
}

.download a {
  margin: 10px;
  text-decoration: none;
}

.download h1,
.download h3 {
  font-weight: normal;
}
.download h1 {
  margin-bottom: 0px;
}

.logo {
  width: 150px;
  height: 150px;
  background: url("../assets/icon.png") center center no-repeat;
  background-size: contain;
  border-radius: 5%;
}

.download-button {
  padding: 15px 30px;
  margin: 20px;
  background: #fff;
  color: #000;
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: bold;
  box-shadow: 10px 10px 0 #2f3570;
}
</style>

<script>
export default {
  name: "download"
};
</script>
